import { useFlag } from '@calendly/feature-check-react'

import { UI_THEME_FLAG_KEY } from './useProductRefreshUiTheme'

export const useShowProductRefreshToggle = () => (
  useFlag(UI_THEME_FLAG_KEY, false)
)
